import Vue from 'vue';

const isInPreview = (thisOfComponent: Vue): boolean => {
  try {
    return thisOfComponent.$router.currentRoute.fullPath.includes('/preview/');
  } catch {
    return false;
  }
};

export default isInPreview;
